import { render } from "./ChangeLog.vue?vue&type=template&id=d3ed2986&ts=true"
import script from "./ChangeLog.vue?vue&type=script&lang=ts"
export * from "./ChangeLog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__